import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SanGameWinFieldController} from "./presentations/SanGameWinFieldController";

export class SanQuentin extends SlotGame {

    protected createWinFieldController(): SanGameWinFieldController {
        return new SanGameWinFieldController();
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L3",
                    "M4",
                    "L1",
                    "L4",
                    "M4"
                ],
                [
                    "M3",
                    "L3",
                    "L5",
                    "L1",
                    "M2"
                ],
                [
                    "S",
                    "M2",
                    "M3",
                    "M4",
                    "M2"
                ],
                [
                    "M4",
                    "L2",
                    "L4",
                    "M2",
                    "L2"
                ],
                [
                    "L3",
                    "M3",
                    "M2",
                    "L4",
                    "L1"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "M4",
                    "L1",
                    "L4",
                    "X"
                ],
                [
                    "X",
                    "L3",
                    "L5",
                    "L1",
                    "X"
                ],
                [
                    "X",
                    "M2",
                    "M3",
                    "M4",
                    "X"
                ],
                [
                    "X",
                    "L2",
                    "L4",
                    "M2",
                    "X"
                ],
                [
                    "X",
                    "M3",
                    "M2",
                    "L4",
                    "X"
                ]
            ],
            "betWayWins": [],
            "totalBetWayWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "freespinTriggeredThisSpin": false,
            "scatterPositionsEnteringFreespin": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "symbolSizes": [
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "mysterySymbolTrigger": false,
            "mysterySymbolReveal": "",
            "cellReelOne": [
                "M4",
                "M5",
                "M4",
                "M2",
                "W"
            ],
            "cellReelTwo": [
                "M4",
                "M1",
                "M2",
                "XWAYS",
                "M5"
            ],
            "topReel": "M4;M5;M4;M2;W;",
            "bottomReel": "M4;M1;M2;XWAYS;M5;",
            "baseScatterWildTrigger": false,
            "topRowOpened": [
                false,
                false,
                false,
                false,
                false
            ],
            "topRowOpenedNew": [
                false,
                false,
                false,
                false,
                false
            ],
            "bottomRowOpened": [
                false,
                false,
                false,
                false,
                false
            ],
            "bottomRowOpenedNew": [
                false,
                false,
                false,
                false,
                false
            ],
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN_3_SCATTERS",
                    "type": "FREESPIN",
                    "price": 100
                },
                {
                    "name": "FREESPIN_4_SCATTERS",
                    "type": "FREESPIN",
                    "price": 400
                },
                {
                    "name": "FREESPIN_5_SCATTERS",
                    "type": "FREESPIN",
                    "price": 2000
                }
            ],
            "wasFeatureBuy": false,
            "featureBet": false,
            "stickyWildPositions": "",
            "doubleXWays": [
                false,
                false,
                false,
                false,
                false
            ],
            "totalWays": 243,
            "specialSymbol": {},
            "brokeTheBank": false
        };
    }
}